import React, { useState, useContext } from 'react';
import './Wishlist.css';
import Header from '../Header';
import Navbar from '../Navbar';
import Footers from '../Footers';
import { CartContext } from '../cart/CartContext';

import productImage from '../services/services-images/l3.webp';
import productImagetwo from '../services/services-images/l5.webp';
import productImagethree from '../services/services-images/l6.jpg';
import productImagefour from '../services/services-images/l7.webp';
const Wishlist = () => {
  const [wishlist, setWishlist] = useState([
    {
      id: 1,
      name: 'Shilajit Capsules',
      price: 499,
      image: productImage,
    },
    {
      id: 2,
      name: 'Ashwagandha Powder',
      price: 299,
      image: productImagetwo,
    },
    {
      id: 3,
      name: 'Ashwagandha Powder',
      price: 299,
      image: productImagethree,
    },
    {
      id: 4,
      name: 'Ashwagandha Powder',
      price: 299,
      image: productImagefour,
    },
  ]);

  const { addToCart } = useContext(CartContext);

  const handleRemove = (id) => {
    setWishlist(prev => prev.filter(item => item.id !== id));
  };

  const moveToCart = (item) => {
    addToCart(item);
    handleRemove(item.id);
  };

  return (
    <div>
      <Header />
      <Navbar />

      <div className="wishlist-container">
        <h2>My Wishlist</h2>

        {wishlist.length === 0 ? (
          <p>Your wishlist is empty. <a href="/shilajit">Continue shopping</a></p>
        ) : (
          <div className="wishlist-items">
            {wishlist.map(item => (
              <div key={item.id} className="wishlist-item">
                <img 
                  src={item.image} 
                  alt={item.name} 
                  className="wishlist-item-img"
                  onError={(e) => { e.target.src = '/fallback-image.jpg'; }}
                />
                <div className="item-info">
                  <h4>{item.name}</h4>
                  <p>₹{item.price}</p>
                  <button onClick={() => moveToCart(item)}>Move to Cart</button>
                  <button className="remove-btn" onClick={() => handleRemove(item.id)}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footers />
    </div>
  );
};

export default Wishlist;




